import Lenis from "lenis";

let lenis = null;
let rafId = null;

export function initLenis() {
  const instance = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
  lenis = instance;
  const raf = (time) => {
    if (lenis !== instance) return;
    instance.raf(time);
    rafId = requestAnimationFrame(raf);
  };
  rafId = requestAnimationFrame(raf);
  return instance;
}

export function destroyLenis() {
  if (rafId) cancelAnimationFrame(rafId);
  rafId = null;
  lenis?.destroy();
  lenis = null;
}

export function scrollToId(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (lenis) {
    lenis.scrollTo(el, { offset: -84, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
